module.exports = __webpack_public_path__ + "img/icon-onboarding-edit.45dce3bf.svg";